import qs from 'qs'

import { putRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassified } from '../../types/api/Classified'
import { classifiedTransformer } from '../../transformers/classifiedTransformer'

type updateResponse = SimpleResult<SClassified>

export type UpdateParams = {
  id: string
  data: any
}

const update = ({ id, data }: UpdateParams) => {
  return putRestRequest({
    url:
      api.REST_API_URL +
      `/classifieds/${id}?${qs.stringify({
        populate: {
          user: {
            fields: ['id'],
          },
          classifiedCategory: {
            fields: ['name', 'form'],
          },
        },
      })}`,
    data: { data },
    transformer: (response: updateResponse) => {
      return classifiedTransformer(response.data)
    },
  })
}

export default update
